var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row success-message text-center m-b-20" }, [
    _c("h1", { staticClass: "title md-title" }, [
      _c("span", {
        directives: [
          {
            name: "class",
            rawName: "v-class",
            value: _vm.welcomeMessageClass,
            expression: "welcomeMessageClass"
          }
        ]
      })
    ]),
    _vm._v(" "),
    _c("p", {
      directives: [
        {
          name: "t",
          rawName: "v-t",
          value: _vm.opClosedLine1,
          expression: "opClosedLine1"
        }
      ],
      staticClass: "subtitle p-t-10 p-b-10"
    }),
    _vm._v(" "),
    _c("p", {
      staticClass: "text-center p-t-15 prp_footer_contact",
      domProps: { innerHTML: _vm._s(_vm.$t("ORP_CLOSED_LINE2")) }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }